import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { RIGHTS_TOPICS, TOPIC_SLUGS } from "../data/rightsTopics";

export default function RightsLibrary() {
  return (
    <div className="min-h-screen bg-[#0A1128] pt-28 pb-20" data-testid="rights-library-page">
      <div className="max-w-7xl mx-auto px-6">
        <nav className="text-xs text-slate-500 flex items-center gap-2 mb-6">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <span>/</span>
          <span className="text-[#B8D0EE]">Rights Library</span>
        </nav>

        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-[#7DA3D9]/25 bg-[#7DA3D9]/5 mb-6">
              <BookOpen className="w-3.5 h-3.5 text-[#7DA3D9]" />
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#B8D0EE] font-semibold">
                Reference Library · {TOPIC_SLUGS.length} topics
              </span>
            </div>
            <h1 className="font-display text-4xl lg:text-7xl tracking-tight leading-[0.98]">
              Every kind of <span className="text-[#7DA3D9]">music right</span>, explained.
            </h1>
          </div>
          <div className="lg:col-span-4">
            <p className="text-slate-300 leading-relaxed text-lg">
              Deep-linkable reference pages for every income-producing right in modern music —
              from publishing and mechanicals to sync, neighbouring, and digital performance.
              Each topic includes the major agencies, licensors, and authorities — clickable
              logos that take you directly to their official sites.
            </p>
          </div>
        </div>

        {/* Featured: Copyright Laws standalone */}
        <Link
          to="/copyright-laws"
          className="block glass-card p-8 lg:p-10 mb-12 border-[#D4AF37]/30 hover:border-[#D4AF37]/60 transition-all"
          data-testid="featured-copyright-laws"
        >
          <div className="overline" style={{ color: "#D4AF37" }}>Foundations</div>
          <h2 className="font-display text-3xl lg:text-5xl mt-3 mb-3">
            Music Copyright Laws
          </h2>
          <p className="text-slate-300 max-w-3xl mb-4">
            The two distinct copyrights in every song (composition vs. sound recording) and
            the six primary royalty streams (performance, mechanical, sync, neighbouring,
            digital performance, print). Start here before any contract.
          </p>
          <span className="text-[#D4AF37] inline-flex items-center gap-1.5 text-sm font-semibold">
            Read the laws <ArrowRight className="w-4 h-4" />
          </span>
        </Link>

        {/* 22-topic grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="topics-grid">
          {TOPIC_SLUGS.map((slug) => {
            const t = RIGHTS_TOPICS[slug];
            return (
              <Link
                key={slug}
                to={`/rights-topic/${slug}`}
                className="glass-card p-6 group"
                data-testid={`library-topic-${slug}`}
              >
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#7DA3D9] font-semibold">
                  {t.overline}
                </div>
                <h3 className="font-display text-xl mt-3 mb-2 group-hover:text-[#B8D0EE] transition-colors">
                  {t.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed line-clamp-3">
                  {t.intro}
                </p>
                <div className="mt-4 text-xs text-slate-500">
                  {t.resources.length} curated resources →
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
